<template>
  <DialogWrapper
    class="confirm-dialog"
    :loading="loading"
    :show.sync="isShow"
    :close-on-click-modal="false"
    :title="title"
    :showClose="false"
    :cancelBtnLabel="cancelBtnLabel"
    :cancelBtnLabelI18nKey="cancelBtnLabelI18nKey"
    :saveBtnLabel="saveBtnLabel"
    :saveBtnLabelI18nKey="saveBtnLabelI18nKey"
    :append-to-body="appendToBody"
    closeOnCancel
    @save="handelConfirm"
    @cancel="handelCancel"
  >
    <span class="content-text">{{ content }}</span>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    DialogWrapper
  },
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    title: {
      type: String
    },
    showTitle: {
      default: true
    },
    content: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    cancelBtnLabel: {
      type: String,
      required: false
    },
    cancelBtnLabelI18nKey: {
      type: String,
      required: false
    },
    saveBtnLabel: {
      type: String,
      required: false
    },
    saveBtnLabelI18nKey: {
      type: String,
      required: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {
    handelConfirm () {
      this.$emit('confirm')
    },
    handelCancel () {
      this.$emit('cancel')
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.confirm-dialog {

  .content-text {
    white-space: pre-wrap;
    word-break: break-word;
  }

  .loading {
    position: absolute;
  }
}
</style>
